// Which Autofake ideas this browser has already shown, so a user never sees the
// same product twice.
//
// Best-effort by nature: private windows, cleared site data, and a second device
// all reset it, so a user CAN see the same idea twice across devices. Readouts
// must therefore count distinct users rather than events.
//
// Keyed by idea, not treatment: the rule is "never the same product twice", and
// alternative treatments of an idea are alternative pitches for something the
// user has already judged.
const STORAGE_KEY = 'autofake:seen';

export function getSeenIdeas(): string[] {
  try {
    const raw = window.localStorage.getItem(STORAGE_KEY);
    if (!raw) return [];
    const parsed: unknown = JSON.parse(raw);
    return Array.isArray(parsed)
      ? parsed.filter((k) => typeof k === 'string')
      : [];
  } catch {
    // Throws outright where site data is blocked; an unreadable list just means
    // "nothing seen", which shows a product rather than suppressing the feature.
    return [];
  }
}

export function markIdeaSeen(ideaKey: string): void {
  try {
    const seen = getSeenIdeas();
    if (seen.includes(ideaKey)) return;
    window.localStorage.setItem(
      STORAGE_KEY,
      JSON.stringify([...seen, ideaKey]),
    );
  } catch {
    // A write failure only costs a possible repeat, never the modal itself.
  }
}
